var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrivio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 8,
    viewBox: "0 0 34 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11120_47299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5465 5.78214V7.92074H3.5572C1.73554 7.92074 0.824863 7.04944 0.824863 5.30691V3.63221H0.000488281V1.53889H0.824863V0H3.43943V1.53889H4.5229V3.63221H3.43943V5.35217C3.43943 5.50314 3.47664 5.61247 3.55127 5.68031C3.62586 5.74817 3.74947 5.78214 3.92228 5.78214H4.5465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13943 1.82593C9.52401 1.60346 9.92448 1.49219 10.3407 1.49219V4.17389H9.59874C9.10418 4.17389 8.74094 4.25699 8.50939 4.42286C8.27767 4.58886 8.16193 4.88302 8.16193 5.30539V7.91926H5.54736V1.53739H8.16193V2.71418C8.42883 2.34469 8.75467 2.04857 9.13943 1.82593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4845 5.53338L19.5444 1.53906H22.3239L20.1098 7.92091H16.8474L14.6333 1.53906H17.4127L18.4845 5.53338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8574 5.55134C31.0224 5.36661 31.1048 5.09314 31.1048 4.73104C31.1048 4.36894 31.0224 4.09558 30.8574 3.91064C30.6925 3.72588 30.4883 3.63344 30.2449 3.63344C30.0016 3.63344 29.7974 3.72588 29.6326 3.91064C29.4677 4.09558 29.3853 4.36894 29.3853 4.73104C29.3853 5.09314 29.4657 5.36661 29.6267 5.55134C29.7876 5.73638 29.9936 5.82858 30.2449 5.82858C30.4883 5.82858 30.6925 5.73638 30.8574 5.55134ZM28.4431 7.60518C27.909 7.34114 27.491 6.96211 27.1888 6.46798C26.8864 5.97391 26.7354 5.39488 26.7354 4.73104C26.7354 4.06731 26.8864 3.48828 27.1888 2.99412C27.491 2.50015 27.909 2.12102 28.4431 1.85691C28.977 1.5929 29.5776 1.46094 30.2449 1.46094C30.9123 1.46094 31.5129 1.5929 32.0469 1.85691C32.5807 2.12102 32.9988 2.50015 33.3011 2.99412C33.6033 3.48828 33.7546 4.06731 33.7546 4.73104C33.7546 5.39488 33.6033 5.97391 33.3011 6.46798C32.9988 6.96211 32.5807 7.34114 32.0469 7.60518C31.5129 7.86928 30.9123 8.00114 30.2449 8.00114C29.5776 8.00114 28.977 7.86928 28.4431 7.60518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0346 7.92683C12.0346 7.63846 12.278 7.40469 12.5781 7.40469C12.8782 7.40469 13.1215 7.63846 13.1215 7.92683H14.1088V1.53906H13.1215C13.1215 1.82741 12.8782 2.0611 12.5781 2.0611C12.278 2.0611 12.0346 1.82741 12.0346 1.53906H11.0474V7.92683H12.0346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0937 1.53125C25.0937 1.8196 24.8504 2.05339 24.5502 2.05339C24.2501 2.05339 24.0068 1.8196 24.0068 1.53125H23.0195V7.91901H24.0068C24.0068 7.63064 24.2501 7.39698 24.5502 7.39698C24.8504 7.39698 25.0937 7.63064 25.0937 7.91901H26.0809V1.53125H25.0937Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11120_47299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrivio);
export default __webpack_public_path__ + "static/media/trivio.1a6651a5ee244d9193b73f0f54ec9510.svg";
export { ForwardRef as ReactComponent };